// Chat Service - Handles API calls and real-time messaging
import api from './api';

const CHAT_API_BASE = '/chat';

// AES-256 encryption for client-side (for display purposes, actual encryption is on server)
const encryptMessage = (message) => {
  // Server handles encryption, but we can add client-side encryption layer if needed
  return message;
};

const decryptMessage = (message) => {
  // Server handles decryption
  return message;
};

const payload = (response) => response?.data?.data || {};

export const chatService = {
  // Get all conversations for the current user
  getConversations: async () => {
    const response = await api.get(`${CHAT_API_BASE}/conversations`);
    return payload(response).conversations || [];
  },

  // Get or create a conversation with another user
  getOrCreateConversation: async (participantId, participantType) => {
    const response = await api.post(`${CHAT_API_BASE}/conversations`, {
      participant_id: participantId,
      participant_type: participantType,
    });
    return payload(response).conversation || payload(response);
  },

  // Get messages for a conversation
  getMessages: async (conversationId, page = 1) => {
    const response = await api.get(`${CHAT_API_BASE}/conversations/${conversationId}/messages`, {
      params: { page }
    });
    return payload(response).messages || [];
  },

  // Send a new message
  sendMessage: async (conversationId, content, messageType = 'text', metadata = null) => {
    const response = await api.post(`${CHAT_API_BASE}/messages`, {
      conversation_id: conversationId,
      content: encryptMessage(content),
      message_type: messageType,
      metadata,
    });
    return payload(response).message;
  },

  // Mark messages as read
  markAsRead: async (conversationId, messageIds) => {
    const response = await api.post(`${CHAT_API_BASE}/messages/read`, {
      conversation_id: conversationId,
      message_ids: messageIds,
    });
    return payload(response);
  },

  // Initiate a call
  initiateCall: async (conversationId, callType) => {
    const response = await api.post(`${CHAT_API_BASE}/calls/initiate`, {
      conversation_id: conversationId,
      call_type: callType,
    });
    return payload(response);
  },

  // Send WebRTC signaling data
  sendSignal: async (callId, signalType, signalData, toUserId) => {
    const response = await api.post(`${CHAT_API_BASE}/calls/signal`, {
      call_id: callId,
      signal_type: signalType,
      signal_data: signalData,
      to_user_id: toUserId,
    });
    return payload(response);
  },
};

export default chatService;
